module.exports = __webpack_public_path__ + "static/img/3.5471859.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo/3.png
// module id = s8Tg
// module chunks = 0